
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.013 10.142l2.499-2.53c.65-.77.65-1.76 0-2.42l-2.499-2.53a1.688 1.688 0 00-2.388 0l-2.497 2.53a1.744 1.744 0 000 2.42l2.497 2.53a1.685 1.685 0 002.388 0zM4.07 9.812h3.475c.977 0 1.737-.77 1.847-1.65V4.533c0-.99-.762-1.76-1.739-1.76H4.07c-.977-.001-1.737.769-1.737 1.759v3.52c0 .99.76 1.76 1.737 1.76zm0 9.021h3.475c.977 0 1.737-.77 1.847-1.76v-3.63c0-.99-.762-1.76-1.739-1.76H4.07c-.977 0-1.737.77-1.737 1.76v3.63c0 .99.76 1.76 1.737 1.76zm12.487 0h-3.584a1.727 1.727 0 01-1.736-1.76v-3.63c0-.99.76-1.76 1.736-1.76h3.584c.976 0 1.736.77 1.736 1.76v3.63c-.108.99-.866 1.76-1.736 1.76z","fill":"currentColor"}})])
          )
        }
      }
    